<template>

    <div>

        <modal
            :title="$t(modalTitle)"
            :width="480"
            cancel-text="Abbrechen"
            transition="fadeDown"
            :show-ok="false"
            :is-show="showModal"
            :on-ok="exportModalOnOk"
            :on-cancel="exportModalOnCancel"
            :backdrop-closable="false"
            @close="showModal=false"
            class="equipmentImagesModal vcenter">


            <template v-if="currentStatus == null">

                <loading-indicator-small></loading-indicator-small>

            </template>

            <template v-else>

                <template v-if="currentStatus.status != 'Finished'">

                    <div class="has-text-centered" style="margin-bottom: 5px;">{{ currentStatus.log }}</div>
                    <progress-bar :percent="currentStatus.progress" :showinfo="false" :striped="true" :animated="true" size="large"></progress-bar>

                </template>

                <template v-else>

                    <div class="has-text-centered">

                        <p>Vorschauverarbeitung abgeschlossen</p>

                    </div>

                </template>

            </template>



        </modal>

        <vue-dropzone
            ref="vueDropzoneCustomizationsPreview"
            id="vueDropzoneCustomizationsPreview"
            url= "fileProcessing/upload?preset=siteCatalogCustomizationsPreviewAsync"
            :formDataAppend = "[{ site: $route.params.siteID }]"
            :isClickable="true"
            :dictDefaultMessage = "`<i class='fa fa-cloud-upload'></i>` + $t('CATALOG_PAGE-PREVIEW_UPLOAD')"
            v-on:vdropzone-success="dzCustomizationsPreviewSuccess"
            dzClass="default">
        </vue-dropzone>

    </div>

</template>


<script>
import vue2Dropzone from '../utils/dropzoneWrapper'

export default {

    name: 'exportToPDF',

    components: {
        vueDropzone: vue2Dropzone
    },

    props: {
        modalTitle: {
            type: String,
            default: 'EXPORT'
        },
        siteCatalog: {
            type: Object
        }
    },

    data () {

        return {

            showModal: false,
            currentStatus: null,
            refreshIntervalId: null
        }

    },

    created() {},

    computed: {},

    watch: {

        showModal(val) {

            if(val == false) {
                clearInterval(this.refreshIntervalId);
            }

        }

    },

    methods: {

        dzCustomizationsPreviewSuccess(file) {

            let result = JSON.parse(file.xhr.response);
            let taskLogId = result.taskLogId;
            let catId = this.$route.params.siteID;
            let self = this;

            self.showModal = true;

            let offset = 0;

            self.refreshIntervalId = setInterval(function() {

                self.axios.get(self.$config.api + 'taskLog/' + taskLogId).then(function(response) {

                    response.data.progress = parseInt(response.data.progress) + offset;
                    self.currentStatus = response.data;

                    if(['Finished', 'Error'].indexOf(response.data.status) > -1) {
                        self.showModal = false;
                        self.$emit('finish');
                        clearInterval(self.refreshIntervalId);
                    }
                });

                offset += 0.2;

                if(offset > 10){
                    offset = 10;
                }

            }.bind(self), 500);


            // remove image from dropzone after some time
			let x = this.$refs.vueDropzoneCustomizationsPreview.$children[0];

			setTimeout(function() {
				x.removeFile(file);
			}, 1500)

        },

        exportModalOnCancel() {

            clearInterval(this.refreshIntervalId);

        },

    }

}

</script>

<style scoped>
    div {
        width: 100%;
        height: 100%;
    }
</style>
